(function () {
  function initPanel(panel) {
    if (panel.dataset.hmbInit === 'true') return;
    var slides = panel.querySelectorAll('.hero-mb__slide');
    if (slides.length < 2) {
      panel.dataset.hmbInit = 'true';
      return;
    }
    panel.dataset.hmbInit = 'true';

    var dots = panel.querySelectorAll('.hero-mb__dot');
    var prevBtn = panel.querySelector('.hero-mb__arrow--prev');
    var nextBtn = panel.querySelector('.hero-mb__arrow--next');
    var current = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay = reduceMotion ? 0 : (parseInt(panel.dataset.autoplay, 10) || 0) * 1000;
    var timer = null;

    function show(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (delay > 0) {
        timer = setInterval(function () {
          show(current + 1);
        }, delay);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(current - 1);
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(current + 1);
        start();
      });
    }
    Array.prototype.forEach.call(dots, function (dot, index) {
      dot.addEventListener('click', function () {
        show(index);
        start();
      });
    });

    panel.addEventListener('mouseenter', stop);
    panel.addEventListener('mouseleave', start);

    start();
  }

  function init(root) {
    var scope = root || document;
    var panels = scope.querySelectorAll('.hero-mb__panel[data-autoplay]');
    Array.prototype.forEach.call(panels, initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
